import { RootState } from 'handlers';

export const getYourEmployer = ({ yourEmployer }: RootState) => yourEmployer;
